import { render, staticRenderFns } from "./MailDraft.vue?vue&type=template&id=62ae7426"
import script from "./MailDraft.vue?vue&type=script&lang=js"
export * from "./MailDraft.vue?vue&type=script&lang=js"
import style0 from "./MailDraft.vue?vue&type=style&index=0&id=62ae7426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports